import React from "react";
import { transformToHtml, getBackgroundImage } from "../../../utils/CommonUtils";
import { getBackgroundColor } from "../../../utils/FlightStatusUtils";

/**
 * UI-only placeholder for OTP/Weather card.
 * API integration will provide real data later.
 */
export default function OtpWeatherCard({ data, logEvent }) {
  if (!data?.subCardsData?.cards?.length) {
    return (
      <div className="otp-weather-card br8 whiteBg">
        <div className="otp-placeholder">OTP & Weather (data will load from API)</div>
      </div>
    );
  }

  const subCards = data.subCardsData.cards;
  const totalFill = subCards.reduce((sum, card) => sum + (card.fillRatio || 1), 0);

  return (
    <div className="otp-weather-card br8 whiteBg">
      <div className="makeFlex gap16">
        {subCards.map((card) => {
          if (!card) return null;
          const widthPercent = ((card.fillRatio || 1) / totalFill) * 100;
          const cardData = card.data || {};

          if (card.type === "WEATHER_INFO") {
            const weather = cardData;
            if (!weather) return null;
            return (
              <section
                key={card.identifier || Math.random()}
                className="weather-section otp-section br8 whiteBg flexCol alignCenter wdth100 padding1624"
                style={{ width: `${widthPercent}%` }}
                aria-label="Weather Info"
              >
                {weather.title && (
                  <div className="fontSize16 boldFont appendBottom12">
                    {transformToHtml(weather.title)}
                  </div>
                )}
                <div className="makeFlex gap32 bottom spaceBetween paddingTop10">
                  {weather.icon && (
                    <span
                      className="bgProperties weather-icon flexOne"
                      style={getBackgroundImage(weather.icon)}
                    />
                  )}
                  <div className="flexCol">
                    {weather.tempText && (
                      <div className="fontSize36 blackFont">
                        {transformToHtml(weather.tempText)}
                      </div>
                    )}
                    {weather.tempSubText && (
                      <div className="fontSize18">{transformToHtml(weather.tempSubText)}</div>
                    )}
                  </div>
                  {weather.weatherInfoList && (
                    <div className="flexCol gap4">
                      {weather.weatherInfoList.map(
                        (info) =>
                          info && (
                            <div key={info} className="fontSize14 flexOne">
                              {transformToHtml(info)}
                            </div>
                          ),
                      )}
                    </div>
                  )}
                </div>
              </section>
            );
          }

          return (
            <section
              key={card.identifier || Math.random()}
              className="otp-section br8 whiteBg flexCol wdth100 padding1624"
              style={{ width: `${widthPercent}%` }}
              aria-label="Flight Performance"
            >
              {cardData.title && (
                <div className="fontSize16 boldFont appendBottom12">
                  {transformToHtml(cardData.title)}
                </div>
              )}
              {cardData.performanceBar && (
                <>
                  <div className="makeFlex spaceBetween alignCenter appendBottom8">
                    {cardData.performanceBar.startUpInfo?.text && (
                      <span className="fontSize14">
                        {transformToHtml(cardData.performanceBar.startUpInfo.text)}
                      </span>
                    )}
                    {cardData.performanceBar.endUpInfo?.text && (
                      <span className="fontSize14 boldFont">
                        {transformToHtml(cardData.performanceBar.endUpInfo.text)}
                      </span>
                    )}
                  </div>
                  <div className="performance-bar-wrap flexCol appendBottom16">
                    <div className="performance-bar-bg br4">
                      <div
                        className="performance-bar-fill br4"
                        style={{
                          width: `${(cardData.performanceBar.fillRatio || 0) * 100}%`,
                          ...getBackgroundColor(cardData.performanceBar.bgColors),
                        }}
                      />
                    </div>
                    {cardData.performanceBar.startDownInfo?.text && (
                      <div className="fontSize12 appendTop4">
                        {transformToHtml(cardData.performanceBar.startDownInfo.text)}
                      </div>
                    )}
                  </div>
                </>
              )}
              {cardData.punctuality && (
                <div className="otp-punctuality-row makeFlex gap32 wdth100">
                  {cardData.punctuality.map(
                    (item) =>
                      item && (
                        <div key={item.title} className="flexCol alignCenter">
                          {item.title && (
                            <div className="fontSize12">{transformToHtml(item.title)}</div>
                          )}
                          {item.text && (
                            <div className="fontSize14 boldFont">
                              {transformToHtml(item.text)}
                            </div>
                          )}
                        </div>
                      ),
                  )}
                </div>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
